module.exports = __webpack_public_path__ + "img/plus.d242b885.svg";